/* 
 * Export component file to be used on project
*/

import Modal from './Modal.js';
export default Modal;
